import {BasePrice} from '@dms/api/shared';

import {Nullish} from 'shared/web';

export type PriceListRowData = {
  name: {value: string};
  catalogNumber: {value: string};
  supplierOrderingNumber: {value: string};
  manufacturerId: {value: {id: string; label: string}};
  supplierId: {value: {id: string; label: string}};
  purchasePrice: {value: BasePrice};
  recommendedPrice: {value: BasePrice};
  supplierDiscountGroup: string;
  supplierManufacturerName: string;
  supplierManufacturerCode: string;
  standardOrderQuantity: string;
  localStock: string;
  totalStock: string;
  supplierAccountCode: string | Nullish;
  supplierOrderTypeCode: string | Nullish;
  branchId: string | Nullish;
  authorizationProfileId: string | Nullish;
};
